var n = 234;
var c = 401;
var obj = {
  s: 'bder' + c,
  d: 'me' + 'c',
  se: 're123',
  dsdtse: 'ger49',
  v: 'bt' + n,
  t: 'wr' + n,
  b: 'asdf1',
  w: '20th',
  dfa: 'fg123fs34',
  vdfa: 'te231'
};
export default obj;